import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { AnalyticsByLineProps } from '../src/components/AnalyticsByLine/AnalyticsByLine.tsx';

export const AnalyticsByLine: LoadableType<Omit<AnalyticsByLineProps, 'flags'>> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-componentsAnalyticsByLine" */ '../src/components/AnalyticsByLine/index.ts'
				)
			).AnalyticsByLine,
	});
